import { createFeatureFlags } from '@thehotelsnetwork/vue-feature-flags';

export const featureFlags = createFeatureFlags(import.meta.env.VUE_APP_LAUNCHDARKLY_API_KEY);
